import $ from 'jquery';
import CustomEvent from 'custom-event';

/* global URL */

const namespace = 'storeswitcher';

export default class StoreSwitcher {
  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          link: '.js-store-link',
          item: '.store-switcher__item',
        },
        classes: {
          active: 'is-active',
        },
      },
      options,
    );
    this.$el = $(el);
    this.el = this.$el.get(0);
    this.$links = this.$el.find(this.options.selectors.link);

    this.init();
    this.bind();
  }

  init() {
    const current = this.getCurrent();

    current
      .parent(this.options.selectors.item)
      .addClass(this.options.classes.active);
  }

  bind() {
    this.$el.on(
      `click.${namespace}`,
      this.options.selectors.link,
      this.handleCurrentClick.bind(this),
    );
  }

  /**
   * @param {Event} event
   */
  handleCurrentClick(event) {
    const {currentTarget} = event;
    const $currentTarget = $(currentTarget);
    const $current = this.getCurrent();

    if ($currentTarget.is($current)) {
      event.preventDefault();
      return;
    }

    const storeEvent = new CustomEvent('switchStore', {
      detail: {
        storeCode: $currentTarget.attr('data-store'),
      },
      bubbles: true,
    });

    this.el.dispatchEvent(storeEvent);
  }

  /**
   * @returns {jQuery}
   */
  getCurrent() {
    const {hostname} = window.location;

    return this.$links.filter((_, item) => {
      const url = $(item).attr('href');

      if (!url) {
        return false;
      }

      try {
        return new URL(url).hostname === hostname;
      } catch (exception) {
        return false;
      }
    });
  }
}
